import { ArrowLeftOutlined, ArrowRightOutlined } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'

import { styled } from 'styled-components'

import { sliderItems } from '../data'
import {mobile} from "../responses"
import { Link } from 'react-router-dom'


const ControlFlow=styled.div`
padding: 0;
margin: 0;
${mobile({display:"none"})};

`
const Container=styled.div`
width:600%;
height:100vh;
display:flex;
    postion:relative;   
    overflow:hidden;
    `
const Arrow=styled.div`
    width:50px;
    height:50px;
    background-color:#fff7f7;
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;
    position:absolute;
    margin:auto;
    cursor:pointer;
    opacity:0.5;
    z-index:2000;
`
    const Wrapper=styled.div`
    height:100%;
    margin:0px;
    display:flex;
    overflow:hidden;
    width:100%;
    transform:translateX(calc(${props=>props.slideIndex} * -16.666666%));
    transition:transform 1.5s ease-in-out;
    `
    const Slide=styled.div`
    padding:2px;
    width:16.66666%;
    height:100vh;
    display:flex;
    align-items:center;
    background-color:#${props=>props.bg};
    overflow:hidden;
    `
    const ImageContainer=styled.div`
    width:100%;
    height:100%;
    flex:1;
    display:flex;
    ${mobile({flex:4})}

    `
    const Image=styled.img`
    height:100%;
    width:100%;
    object-fit: cover;
    object-position: 70% 50%;
    border-radius:12px 0px 0px 12px;
    
    `
    const InfoContainer=styled.div`
    height:50vh;
    flex:1;
    padding-left:20px;
    `
    const Title=styled.h1`
    font-size:70px;

`
    const Desc=styled.p`
    margin:50px 0px;
    font-size:20px;
    font-weight:500px;
    letter-spacing:3px;
`
    const Button=styled.button`
    padding:10px;
    font-size:20px;
    background-color:transparent;
    cursor:pointer;
`
var intervalId;
const Slider = () => {
    // 
    const [slideIndex,setSlideIndex]=useState(0)
    const [click,setClick]=useState(false)
    const handleCLick=(direction)=>{
        if(direction==="left"){
            setSlideIndex(slideIndex>0?slideIndex-1:5)
        }
        else{
            setSlideIndex(slideIndex<5?slideIndex+1:0)
        }
        setClick(true)
    }
    useEffect(()=>{
        if(click){
            window.clearTimeout(intervalId)
            // console.log({intervalId});
            
        }
        else
        {
        intervalId=setTimeout(() => {
            setSlideIndex(slideIndex<5?slideIndex+1:0)
                }, 3000);
        }
    })
    return (
        <ControlFlow>
        
    <Container>
        <Arrow direction="left" style={{top:"50%",left:"10px"}}
        onClick={()=>handleCLick("left")}
        >
            <ArrowLeftOutlined/>
        </Arrow>
        <Wrapper 
        slideIndex={slideIndex}
        >

            {sliderItems.map(({title,desc,bg,id,img:img1,style})=>{
                
        return(
                
        <Slide bg={bg} key={id}>
            <ImageContainer>
                <Image src={img1} style={style}/>
            </ImageContainer>
            <InfoContainer>
                <Title>{title}</Title>
                <Desc>{desc}</Desc>
                <Link to={"/products"} >
                    <Button>
                    SHOP NOW
                    </Button>
                </Link>
            </InfoContainer>
        </Slide>
            )}
        )}



        </Wrapper>

        <Arrow direction="right" style={{top:"50%",right:"10px"}}
        onClick={()=>handleCLick("right")} 
        >
            <ArrowRightOutlined/>
        </Arrow>
    </Container>


    </ControlFlow>
  )
}

export default Slider
